module.exports = __webpack_public_path__ + "img/modelo_small12.1b22f4eb.png";